// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicJsonListItem_root__2Ap0N","txt":"PlasmicJsonListItem_txt__3iWMu"};